import { FC } from 'react';

import {
  ButtonsWrapper,
  CancelButton,
  ModalTextWrapper,
  ModalTitle,
  ModalWrapper
} from '@anm/components/stream/destination_management/ConnectToFacebookModal/Wrapper';

type FacebokErrorModalProps = {
  onModalClose: () => void;
};

const FacebokErrorModal: FC<FacebokErrorModalProps> = ({ onModalClose }) => (
  <ModalWrapper {...{ onModalClose }}>
    <ModalTitle title="Can't add facebook destination" />
    <ModalTextWrapper>
      Facebook destination error. Please try again later or contact support at{' '}
      <a href="mailto:support@wave.video">support@wave.video</a>
    </ModalTextWrapper>

    <ButtonsWrapper>
      <CancelButton variant="white-blue-border-share" size="medium" onClick={onModalClose}>
        Close
      </CancelButton>
    </ButtonsWrapper>
  </ModalWrapper>
);

export default FacebokErrorModal;
